import React, { useEffect, useRef, forwardRef } from 'react'
import { DragOutlined } from '@ant-design/icons'

import { renderTranslation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { quantitySectionContainer, quantitySectionId } from '../../../Constants/Configuration'
import Quantities from './Quantities'
import { useAppSelector } from '../../../hooks'

function QuantitiesGridLayout({ style, className, onMouseDown, onMouseUp, onTouchEnd, children, ...props }, ref) {
  const language = useAppSelector(state => state.present.language.value)
  const articleSelected = useAppSelector(state => state.present.articleDetail.articleSelected)
  const quantitiesTabVisible = useAppSelector(state => state.present.configuration.isTabQuantitiesVisibile)
  const workspaceQuantitiesTabVisible = useAppSelector(state => state.present.configuration.workspaceQuantitiesVisible)
  const quantities = useAppSelector(state => state.present.articleDetail.articleSelected.quantities)

  const emptyClass = quantities?.length > 0 ? '' : ' emptyBar'

  const quantityBoxDomElementRef = useRef(null)

  const isQuantitiesFetched = articleSelected.fetchedQuantities

  const isQuantityBoxVisible = quantitiesTabVisible && workspaceQuantitiesTabVisible

  useEffect(() => {
    const quantityRef = quantityBoxDomElementRef.current
    quantityRef && props.domElementsRefObserver && props.domElementsRefObserver.observe(quantityRef)

    return () => {
      quantityRef && props.domElementsRefObserver && props.domElementsRefObserver.unobserve(quantityRef)
    }
  }, [props.domElementsRefObserver, quantityBoxDomElementRef])

  useEffect(() => {
    //essential for first render to match container width
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }, [])

  return (
    <div
      id={quantitySectionId}
      grid-data={props.datagrid}
      className={className + (!isQuantityBoxVisible || !isQuantitiesFetched ? ' d-none' : '')}
      style={{ ...style }}
      ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
    >
      <div className='grid-layout-adjust-wrapper'>
        <div className='drag-handle-grid-container'>
          <DragOutlined />
        </div>
        <div className='diwa-container' ref={quantityBoxDomElementRef} id={quantitySectionContainer}>
          <div className={`label-drag ${emptyClass}`}>
            {renderTranslation(language, TranslationKeys.buttonSituationSection)}
          </div>
          <Quantities />
        </div>
      </div>
    </div>
  )
}

export default forwardRef(QuantitiesGridLayout)
